export function profilePasswordError(password = "", confirmPassword = "") {
    if (!password && !confirmPassword) return null;
    if (password.length < 6) return "minimum-length-password-error";
    if (!confirmPassword) return null;
    if (password !== confirmPassword) return "confirm-password-error";
    return null;
}

export function isProfilePasswordValid(password = "", confirmPassword = "") {
    return password.length >= 6 && password === confirmPassword;
}
